import { useSelector } from 'react-redux';

const useHasPermission = (permissions = []) => {
    const account = useSelector((state) => state.account);

    const userPermissions = account?.user?.perms ?? {};
    // const userPermissions = account.scopes ?? [];
    // console.log('useHasPermission::userPermissions', userPermissions);
    // console.log('useHasPermission::permissions', permissions);
    if (typeof permissions === 'string' || permissions === null) {
        console.error('Invalid parameter for useHasPermission hook!');
        throw Error('Invalid parameter for useHasPermission hook!');
    }

    if (permissions.length === 0) {
        return true;
    }

    if (!Array.isArray(permissions?.[0])) {
        permissions = [permissions];
    }
    // const response = permissions.some(([section, operation]) => (
    //     Boolean(userPermissions?.[section] && userPermissions[section].includes(operation))
    // ));
    // const response = permissions.some(([section, operation]) => (
    //     Boolean(userPermissions.includes(`${operation}__on__${section}`))
    // ));
    const response = permissions.some(([section, operation]) => (
        Boolean(userPermissions?.[section] && userPermissions[section].includes(operation))
    ));
    // console.log('useHasPermission::response', response);

    return response;
};

export const getNestedPermission = (nestedKey, item) => {
    // console.log('getNestedPermission', item);
    if (item.permissions) {
        return item.permissions;
    }

    if (item?.[nestedKey]) {
        return item?.[nestedKey].reduce((permissions, nestedRoute) => {
            let nestedRoutePermission = nestedRoute.permissions;
            // console.log("nestedRoutePermission", nestedRoutePermission);
            if (!nestedRoutePermission) {
                return permissions;
            }

            if (!Array.isArray(nestedRoutePermission?.[0])) {
                nestedRoutePermission = [nestedRoutePermission];
            }

            return [...permissions, ...nestedRoutePermission];
        }, []);
    }

    return [];
};

export default useHasPermission;
